import { render, staticRenderFns } from "./Ckhc.vue?vue&type=template&id=4a4bf8b7&scoped=true&"
import script from "./Ckhc.vue?vue&type=script&lang=js&"
export * from "./Ckhc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bf8b7",
  null
  
)

export default component.exports